import { IconButton, styled } from '@mui/material';

const CloseButton = styled(IconButton)(
  ({ theme }) => `
    size: small;
    transition: all .2s;

    &:hover {
      background-color: rgba(255, 0, 0, 0.13);
      color: ${theme.palette.error.main};
    }
  `
);

export default CloseButton;
